import { render, staticRenderFns } from "./ReportPatientsDataTableComponent.vue?vue&type=template&id=40b60de7"
import script from "./ReportPatientsDataTableComponent.vue?vue&type=script&lang=js"
export * from "./ReportPatientsDataTableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports